import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import {
  darkMenuItemActive,
  darkMenuItemHover,
  darkMenuItemPressed,
  dropdownWithTriangle,
} from '../../styles/dropdownMixins';
import { FA_SELECTOR } from '../../styles/variables';

export const useNavElementsStyles = createStyles(({ token }) => {
  const dropdownOverlayBase = dropdownWithTriangle({
    menuCustom: { width: 140 },
    menuItemCustom: { color: ThemeColors.COLOR_GREY6 },
  });
  return {
    linksRow: {
      display: 'flex',
      alignItems: 'center',
      fontSize: token.fontSizeSM,

      '> *': {
        whiteSpace: 'nowrap',
      },
    },
    // Passed directly as `className` onto each `<VerticalDivider>` instance
    // rendered inside `LinksRow` — compound with `VerticalDivider`'s own
    // hash, not a descendant selector reaching into it.
    linksRowDivider: {
      '&&': {
        [`@media (min-width: ${token.screenSMMin}px), (max-width: ${token.screenSMMax}px)`]:
          {
            margin: `0 ${ThemeSpaces.SPACE_NORM}px`,
          },
        [`@media (max-width: ${token.screenXSMax}px)`]: {
          margin: `0 ${ThemeSpaces.SPACE_XS}px`,
        },
      },
    },

    dropdownMenuLabel: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      lineHeight: 1,

      [FA_SELECTOR]: {
        marginLeft: ThemeSpaces.SPACE_XS,
      },
    },

    dropdownMenuOverlay: {
      ...dropdownOverlayBase,

      '.ant-dropdown-menu': {
        ...dropdownOverlayBase['.ant-dropdown-menu'],

        '.ant-dropdown-menu-submenu-title': {
          borderRadius: '0 !important',
          backgroundColor: 'inherit',

          '&:hover': {
            position: 'relative',
            zIndex: 1,
            backgroundColor: 'inherit',
          },
        },

        '.ant-dropdown-menu-submenu-disabled': {
          opacity: 0.5,
        },
      },
    },

    iconTrigger: dropdownWithTriangle({
      menuCustom: { width: 140 },
      trianglePositionMultiplier: 1 / 2,
    }),

    dropdownThemeDark: dropdownWithTriangle({
      menuCustom: { width: 140 },
      menuItemCustom: { color: ThemeColors.COLOR_GREY_BLUISH3 },
      itemActive: darkMenuItemActive,
      itemHover: darkMenuItemHover,
      itemPressed: darkMenuItemPressed,
      boxShadow: `0px 1px 60px ${ThemeColors.COLOR_BLACK1}`,
      borderColor: ThemeColors.COLOR_GREY_BLUISH2,
      backgroundColor: ThemeColors.COLOR_GREY_DARK5,
    }),

    dropdownSizeLarge: {
      '.ant-dropdown-menu': {
        '.ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title': {
          height: 40,
          fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
          fontWeight: 'normal',
          fontFamily: ThemeFont.FONT_FAMILY,
        },
      },
    },

    dropdownThemeAlt: {
      '.ant-dropdown-menu': {
        '.ant-dropdown-menu-item, .ant-dropdown-menu-submenu': {
          '&:nth-child(even)': {
            backgroundColor: '#e5ebf0',
          },
          '&:nth-child(odd)': {
            backgroundColor: ThemeColors.COLOR_WHITE4,
          },

          '.ant-dropdown-menu-submenu-expand-icon': {
            position: 'relative',
            left: 0,
            order: 0,
            color: 'inherit',
            svg: {
              lineHeight: '22px !important',
              fontWeight: '900 !important',
              fontSize: 12,
              path: {
                stroke: 'currentColor !important',
                strokeWidth: '80 !important',
              },
            },
          },

          '.ant-dropdown-menu-title-content': {
            flex: 1,
            paddingRight: '25px !important',
            order: -1,
          },
          '&:not(.ant-dropdown-menu-submenu-disabled):hover': {
            backgroundColor: ThemeColors.COLOR_RED,
            color: `${ThemeColors.COLOR_WHITE} !important`,
          },
        },

        ':not(.ant-dropdown-menu-submenu-disabled).ant-dropdown-menu-submenu:hover':
          {
            '.ant-dropdown-menu-submenu-title': {
              color: ThemeColors.COLOR_WHITE,
            },
          },
      },
    },
  };
});
